import React, { useEffect, useState } from "react";
import { getAllGallery, deleteGallery } from "./FetchApi";

const AllGallery = ({ refreshFlag }) => {
  const [items, setItems] = useState([]);

  const load = async () => {
    let res = await getAllGallery();
    if (res && res.gallery) setItems(res.gallery);
  };

  useEffect(() => {
    load();
  }, [refreshFlag]);

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer ce média ?")) return;
    let res = await deleteGallery(id);
    if (res && res.success) {
      load();
    } else if (res && res.error) {
      alert(res.error);
    }
  };

  return (
    <div className="bg-white p-4 rounded shadow">
      <h3 className="font-semibold mb-3">Médias</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {items && items.length ? (
          items.map((it) => (
            <div key={it._id} className="border rounded p-2">
              {it.mediaType && it.mediaType.startsWith("video") ? (
                <video controls className="w-full h-48 object-contain">
                  <source src={`${process.env.REACT_APP_API_URL}/uploads/gallery/${it.filename}`} />
                </video>
              ) : (
                <img
                  src={`${process.env.REACT_APP_API_URL}/uploads/gallery/${it.filename}`}
                  alt="media"
                  className="w-full h-48 object-cover"
                />
              )}
              <div className="flex justify-between items-center mt-2">
                <small className="text-xs text-gray-500">{it.originalName}</small>
                <button
                  onClick={() => handleDelete(it._id)}
                  className="text-red-600 text-sm"
                >
                  Supprimer
                </button>
              </div>
            </div>
          ))
        ) : (
          <p className="text-gray-500">Aucun média trouvé</p>
        )}
      </div>
    </div>
  );
};

export default AllGallery;
